import React, { useContext } from 'react'

const LayerContext = React.createContext()

const LayerDetails = ({ handleLayerChange }) => {
  const selectedLayer = useContext(LayerContext)

  return (
    <div
      className={'p-2 mr-5 mb-1 w-full rounded-lg bg-zinc-700 bg-opacity-70" '}
    >
      <div
        className={`flex items-center justify-between cursor-pointer rounded-lg p-2 ${
          selectedLayer === 'aqi_eu'
            ? 'text-white bg-zinc-900'
            : 'text-gray-400'
        } ${selectedLayer === 'aqi_eu' ? 'bg-blue-500' : ''}`}
        onClick={() => handleLayerChange('aqi_eu')}
      >
        <span className='font-bold text-sm'>AQI</span>
      </div>
      <div
        className={`flex items-center justify-between cursor-pointer rounded-lg p-2 ${
          selectedLayer === 'pm25' ? 'text-white bg-zinc-900' : 'text-gray-400'
        } ${selectedLayer === 'pm25' ? 'bg-blue-500' : ''}`}
        onClick={() => handleLayerChange('pm25')}
      >
        <span className='font-bold text-sm'>PM2.5</span>
      </div>
      <div
        className={`flex items-center justify-between cursor-pointer rounded-lg p-2 ${
          selectedLayer === 'pm10' ? 'text-white bg-zinc-900' : 'text-gray-400'
        } ${selectedLayer === 'pm10' ? 'bg-blue-500' : ''}`}
        onClick={() => handleLayerChange('pm10')}
      >
        <span className='font-bold text-sm'>PM10</span>
      </div>
      <div
        className={`flex items-center justify-between cursor-pointer rounded-lg p-2 ${
          selectedLayer === 'no2' ? 'text-white bg-zinc-900' : 'text-gray-400'
        } ${selectedLayer === 'no2' ? 'bg-blue-500 ' : ''}`}
        onClick={() => handleLayerChange('no2')}
      >
        <span className='font-bold text-sm'>NO2</span>
      </div>
      <div
        className={`flex items-center justify-between cursor-pointer rounded-lg p-2 ${
          selectedLayer === 'o3' ? 'text-white bg-zinc-900' : 'text-gray-400'
        } ${selectedLayer === 'o3' ? 'bg-blue-500 ' : ''}`}
        onClick={() => handleLayerChange('o3')}
      >
        <span className='font-bold text-sm'>O3</span>
      </div>
    </div>
  )
}

export default LayerDetails
